import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { DialogContext } from '../../../../store/context/DialogContext';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';
import BusinessV2FieldGrid from './BusinessV2FieldGrid';
import { collectVisibleFieldErrors, getFieldErrorValue, getNextStepV2, getVisibleWizardFieldOrder, V2_TYPE } from './helperV2';

const AssetsInvolvement = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    applicationForm,
    isForEDD,
    handleChange,
    handlePrev,
    setData,
    formType,
    editMode,
    jsonConfig,
    pageNum = 1,
}) => {
    const { showError } = useContext(DialogContext);
    const applicationType = Number(applicationForm?.type);
    const wizardLabel = jsonConfig?.wizardLabels?.[wizard] || "Cryptocurrency and Digital Assets Involvement";
    const visibleFieldOrder = (() => {
        if (applicationType === V2_TYPE.PLUS) return [];
        return getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
            type: applicationType,
        });
    })();

    if (applicationType === V2_TYPE.PLUS) {
        return null;
    }

    const checkNext = () => {
        const { fieldErrors } = collectVisibleFieldErrors({
            data,
            step: { wizard },
            iPlusFields,
            errors,
            type: applicationType,
        });
        const mergedErrors = {
            ...(errors || {}),
            ...fieldErrors,
        };
        setErrors(mergedErrors);

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = getFieldErrorValue(mergedErrors, fieldPath);
            if (fieldError) {
                setHasError(true);
                if (fieldError) {
                    showError(fieldError);
                    return false;
                }
            }
        }

        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStepV2(wizard, applicationType, data, jsonConfig) });
        }
    };

    return (
        <div className="business-v2-step-shell">
                <div className="business-v2-step-header">
                    <h2 className='business-v2-step-title'>{wizardLabel}</h2>
                </div>

                <BusinessV2FieldGrid
                        fieldOrder={visibleFieldOrder}
                        fieldMap={cyclosFields}
                        data={data}
                        asLabel={asLabel}
                        handleChange={handleChange}
                        hasError={hasError}
                        onFieldError={(field, errorMsg) => setErrors((prevErrors) => ({ ...(prevErrors || {}), [field]: errorMsg }))}
                        dataTestId='business-v2-assets-involvement-fields'
                    />

                <div className='business-v2-step-actions'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={pageNum}
                        showPageNum={false}
                        pageNum={pageNum}
                        hideSubmitButton={hideButtons}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
        </div>
    );
};

export default observer(AssetsInvolvement);
